import { VSTUI } from 'vstui';
import chameleonjs, { colors } from "chameleonjs";
import { ocean } from "@vitalsource/vstui/colors";

var Brands = (function(){

  var Brands = function(){
    // this should be overridden when the init() function is called
    this.brand_name = 'default';

    this.chameleonBrandFailed = function(brand, external, reason) {
      setTimeout(() => {
        Fraction.Reporter.gaEvent("NonChameleonBrand", reason, `${brand} - ${external}`);
      }, 5000);
    };

    // Initialize the brand
    this.init = async function(path, brand, external){
      return chameleonjs.loadBrand(brand, "fraction")
      .then(finalBrand => {
        $.extend(true, Fraction.Helpers.getDataObject("Branding"), finalBrand);
        Fraction.Brand = Fraction.Helpers.getDataObject("Branding");
        this.updateVSTUITheme();
        Promise.resolve();
      })
      .catch((error) => {
        this.chameleonBrandFailed(brand, external, error.message);
      });
    };

    this.getColorByKey = function(key) {
      return colors[key] || colors["ocean"] || ocean;
    };

    this.getPaletteColors = function() {
      switch (Fraction.Brand.theme){
        case 'brickish':
          // DO NOT CHANGE OR MACMILLAN WILL GO GRRRRRR
          const macmillanColor = this.getColorByKey("macmillan");
          return [macmillanColor, macmillanColor, macmillanColor];
        default:
        return [
          this.getColorByKey(Fraction.Brand.Theme.base), 
          this.getColorByKey(Fraction.Brand.Theme.primary), 
          this.getColorByKey(Fraction.Brand.Theme.secondary)
        ];
      }
    };

    this.getShadeArray = function(key) {
      const color = this.getColorByKey(key);
      return [
        "",
        color.getShade(1),
        color.getShade(2),
        color.getShade(3),
        color.getShade(4),
        color.getShade(5),
        color.getShade(6),
        color.getShade(7),
        color.getShade(8),
        color.getShade(9),
        color.getShade(10)
      ];
    };

    this.updateVSTUITheme = function() {
      switch (Fraction.Brand.theme){
        case 'brickish':
          // DO NOT CHANGE OR MACMILLAN WILL GO GRRRRRR
          VSTUI.changeTheme(this.getShadeArray("macmillan"), this.getShadeArray("macmillan"), "macmillan");
        break;
        default:
          VSTUI.changeTheme(
            this.getShadeArray(Fraction.Brand.Theme.primary),
            this.getShadeArray(Fraction.Brand.Theme.secondary),
            Fraction.Brand.Theme.primary
          );
        break;
      }
    };

    // Get the current brand name, not sure if this will
    // ever be used
    this.getCurrentBrand = function(){
      return this.brand_name;
    };

  };

  return new Brands();
}());

module.exports = Brands;
